export type NatureR03AccessSnapshot = {
  naturePanel: HTMLElement | null;
  cameraVideo: HTMLVideoElement | null;
  cameraStream: MediaStream | null;
  cameraStatus: string | null;
};

type Listener = (snapshot: NatureR03AccessSnapshot) => void;

const EMPTY_ACCESS: NatureR03AccessSnapshot = {
  naturePanel: null,
  cameraVideo: null,
  cameraStream: null,
  cameraStatus: null,
};

let currentAccess: NatureR03AccessSnapshot = EMPTY_ACCESS;
const listeners = new Set<Listener>();

export function getNatureR03Access(): NatureR03AccessSnapshot {
  return currentAccess;
}

export function publishNatureR03Access(snapshot: NatureR03AccessSnapshot) {
  currentAccess = snapshot;
  for (const listener of listeners) listener(snapshot);
}

export function clearNatureR03Access() {
  publishNatureR03Access(EMPTY_ACCESS);
}

export function subscribeNatureR03Access(listener: Listener) {
  listeners.add(listener);
  listener(currentAccess);
  return () => listeners.delete(listener);
}
